/* eslint-disable */
import { ajax } from "noquery-ajax";
import { httpsLogger } from "../p1s7/p1s7e1";
import { last } from "lodash";

interface Arguments {
  recycler_uid: string;
  recycler_location_uid: string;
  phone_number: string;
  employee_uid: string;
  first_name?: string;
  last_name?: string;
  conversation_starter_custom_message?: string;
}

function sendConversationInvite({
  recycler_uid,
  recycler_location_uid,
  employee_uid,
  phone_number,
  first_name,
  last_name,
  conversation_starter_custom_message,
  
}: Arguments) {
  return new Promise(function (resolve, reject) {
    let params = {
      firebase_uid: window.G_firebase_auth.IV_uid,
      firebase_token: window.G_firebase_auth.IV_id_token,
      firebase_email: window.G_firebase_auth.IV_email_address,
      recycler_uid: recycler_uid,
      recycler_location_uid: recycler_location_uid,
      queue_request_source: 1,
      conversation_type: 5,
      phone_number: phone_number,
      employee_uid: employee_uid,
      ...(first_name !== undefined && {first_name: first_name}),
      ...(last_name !== undefined && {last_name: last_name}),
      ...(conversation_starter_custom_message !== undefined && {conversation_starter_custom_message: conversation_starter_custom_message}),
    };

    ajax({
      url: window.G_cloud_p1s3_base_url + "p1s3e16QueueConsumerConversation",
      headers: {
        Accept: "application/json",
      },
      method: "POST",
      dataType: "json",
      data: params,
      success: function (result) {
      	let response_data = {
      	  success: true,
          response: result,
          request_params: params
        }
        resolve(response_data);
      },
      error: function (error) {
        let error_data = {
          success: false,
          request_object: error,
          request_params: params,
          file_name: "p1s3e16.ts",
          class_name: "p1s3e16",
          method_name: "sendConversationInvite",
          error_title: "Failed to send conversation invite to customer",
          error_description:
            "The server responded with an error when trying to send a conversation invite to customer",
        };

        httpsLogger(error_data);
        reject(error_data);
      },
    });
  });
}

export default sendConversationInvite;
